<template>
    <div>
        <loader-component v-if="isSendingDataToServer"></loader-component>
        <loader-component v-if="showLoader"></loader-component>
        <div v-else>
            <!-- responsive-header -->
            <responsive-header-component></responsive-header-component>
            <!-- responsive-header -->

            <div class="wrapper default">

                <!-- header -->
                <header class="main-header default">
                    <div class="container">
                        <header-component></header-component>
                    </div>
                    <navbar-component></navbar-component>
                </header>
                <!-- header -->

                <main class="compare-page default">
                    <div class="title-compare"><span class="title">لیست مقایسه محصولات<span> </span> </span></div>
                    <div class="container" style="overflow:auto">
                        <div class="row" style="width:1300px">
                            <div class="div-box" v-for="product in comparedProducts">
                                <div class="close-product-box" @click="removeProductFromComparedList(product.Id)"><i class="now-ui-icons ui-1_simple-remove"></i></div>
                                <div class="box">
                                 
                                    <div class="compare-image"><img :src="product.PicPath" @error="imageLoadOnError" /></div>
                                    <div class="product-name"><span>{{ product.Name }}</span></div>
                                    <div class="col-1-12 mt30 center">
                                        <router-link class="btn buy-btn" tag="a" :to="{ name: 'product' , params: { productId: product.Id , productName: product.Name } }">مشاهده و خرید محصول</router-link>
                                    </div>
                                </div>
                            </div>
                            <div v-if="comparedProducts != null && comparedProducts.length < 4 " class="div-box-add">
                                <div class="box">
                                    <div class="add-compare-product">
                                        <div class="c-compare__placement">
                                            <div class="img-add-product"><img src="/assets/img/add-product.svg" /></div>
                                            <span class="text-add">برای افزودن کالا به لیست مقایسه کلیک کنید</span>
                                        </div>
                                    </div>
                                    <div class="div-btn">
                                        <button @click="searchProducts" data-toggle="modal" data-target="#addProductToCompareModal" class="btn add-btn">افزودن کالا به مقایسه</button>
                                    </div>
                                </div>
                            </div>
                            <div class="div-compare-details col-md-12">
                                <ul v-for="info in comparedProductsProperiesByGroups" class="content">
                                    <li><div class="title-details"><span>{{info.GroupName}}</span></div></li>
                                    <li style="position:relative;margin-top: 40px;margin-bottom: 20px" v-for="Property in info.comparedProductProperies">
                                        <span class="propertyTilte" style="">{{Property.PropertyName}}</span>
                                        <div class="value-list-compare"><span class="block">{{(Property.ProductA_PropertyValue == null || Property.ProductA_PropertyValue) == '' ? '---' : Property.ProductA_PropertyValue  }}</span></div>
                                        <div class="value-list-compare"><span class="block">{{(Property.ProductB_PropertyValue == null || Property.ProductB_PropertyValue) == '' ? '---' : Property.ProductB_PropertyValue  }}</span></div>
                                        <div class="value-list-compare"><span class="block">{{(Property.ProductC_PropertyValue == null || Property.ProductC_PropertyValue) == '' ? '---' : Property.ProductC_PropertyValue  }}</span></div>
                                        <div class="value-list-compare"><span class="block">{{(Property.ProductD_PropertyValue == null || Property.ProductD_PropertyValue) == '' ? '---' : Property.ProductD_PropertyValue  }}</span></div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </main>
                <footer-component></footer-component>
            </div>

        </div>
        <!-- Modal -->
        <div class="modal fade" id="addProductToCompareModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div :class="{ loader: !isShowSppiner }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%"><img style="position:absolute;top:50%;left:46%;z-index:100" src="/assets/img/loader/loader.svg" /></div>
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">لیست محصولات</h5>
                        <button type="button" class="close" @click="closeModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="container">
                            <div class="row">
                                <div class="search-box input-group mb-3 col-md-12" style="direction:ltr">
                                    <div class="">
                                        <button class="btn btn-outline-secondary" type="button" @click="searchProducts">جستجو</button>
                                    </div>
                                    <input v-model="searchValue" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" type="text" class="form-control" placeholder="" aria-label="Example text with button addon" aria-describedby="button-addon1">
                                </div>
                                <div class="item-product col-12">
                                    <div class="row">
                                        <div v-if="productsFound.length != 0" v-for="product in productsFound" class="item col-md-4 col-xs-12" @click="addProductToCompareList(product.Id)">
                                            <div class="item-content">
                                                <div class="img-compare">
                                                    <img :src="product.PicPath" @error="imageLoadOnError" />
                                                </div>
                                                <div class="text-compare">
                                                    <span>{{product.Name}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="productsFound.length == 0" class="item col-md-12 col-xs-12">
                                            <div class="div-box-empty-product">
                                                <div class="empty-product col-xs-12">
                                                    <img src="/assets/img/emptyProduct.svg" />
                                                    <span>محصول مورد نظر یافت نشد.</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--/Modal-->
    </div>
</template>

<script>
    $(function () {
        $('.div-box:nth-child(4)').css('border-left', 'none');
    });
    import { httpPromise } from "../../module/httpUtility";
    import { initialSite } from "../../module/initialSite";
    import { isArray } from "util";

    export default {
        data() {
            return {
                comparedProductsProperiesByGroups: [],
                comparedProducts: [],
                compareProductsList: [],
                productsFound: [],
                isShowSppiner: false,
                showLoader: false,
                isSendingDataToServer: false , 
                searchValue: '',
            }
        },
        beforeMount: function () {
            initialSite(this);
            createPageTitle('مقایسه محصولات');
            this.handleRequest();
        },
        beforeRouteEnter: function (to, from, next) {
            if (IsNullOrEmptyString(to.query.SubGroupId)) {
                next('/');
            } else {
                next(true);
            }
        },
        watch: {
            $route: function (to, from) {
                this.handleRequest();
            }
        },
        methods: {
            closeModal() {
                $(function () { $('#addProductToCompareModal').modal('hide'); });
                this.searchValue = '';
            },
            removeProductFromComparedList(productId) {
                this.compareProductsList = this.compareProductsList.filter(el => el != productId);
                this.rebulidQueryString();
            },
            rebulidQueryString() {
                var data = {
                    SubGroupId: this.$route.query.SubGroupId,
                    productId: this.compareProductsList
                }
                this.$router.push({ name: 'compareProduct', query: data });
            },
            handleRequest() {
                this.compareProductsList = [];
                if (this.$route.query.productId != null) {
                    if (isArray(this.$route.query.productId)) {
                        this.compareProductsList = this.$route.query.productId;
                    } else {
                        this.compareProductsList.push(this.$route.query.productId);
                    }
                } else {
                    this.compareProductsList = [];
                }
                this.compareProducts();
            },
            searchProducts() {
                this.isShowSppiner = true;
                httpPromise(this, '/v1/ProductManagement/CompareProducts/Search', 'get', { SubGroupId: this.$route.query.SubGroupId, SearchValue: this.searchValue },
                    response => {
                        toastr.remove();
                        this.productsFound = response.data.Value;
                        this.isShowSppiner = false;
                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                        this.isShowSppiner = false;
                    }
                );
            },
            compareProducts() {
                this.isSendingDataToServer = true;
                var data = this.compareProductsList.join();
                httpPromise(this, '/v1/ProductManagement/CompareProducts/Operation', 'get', { ProductsIds: data}  ,
                    response => {
                        toastr.remove();
                        this.comparedProducts = response.data.Value.ComparedProducts;
                        this.compareProductsList = response.data.Value.ComparedProducts.map(a => a.Id);
                        this.comparedProductsProperiesByGroups = response.data.Value.ComparedProductsProperiesByGroups;
                        this.isSendingDataToServer = false;

                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                        this.isSendingDataToServer = false;
                    }
                );
            },
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-image-available.png";
            },
            addProductToCompareList(productId) {
                var result = this.compareProductsList.filter(c => c == productId);
                if (result != 0) {
                    toastr.remove();
                    toastr.error('این محصول در لیست مقایسه موجود هست');
                    return;
                }
                if (this.compareProductsList.length >= 4) {
                    toastr.remove();
                    toastr.error('حداکثر 4 محصول قابلیت مقایسه با یکدیگر را دارند');
                    return;
                }
                this.compareProductsList.push(productId);
                this.rebulidQueryString();
                this.closeModal();
            }
        }
    }
</script>

<style scoped>
    .title-details:after {
        content: "";
        position: absolute;
        right: 13px;
        bottom: 32px;
        width: 0;
        height: 0;
        border-color: transparent #00bfd6 transparent transparent;
        border-style: solid;
        border-width: 7px 7px 7px 0;
    }
    .div-img-p {
        text-align:center;
    }
    .price .discount {
        position: absolute;
        color: #c99;
        top: -16px;
    }

        .price .discount::after {
            content: '';
            width: 100%;
            position: absolute;
            left: 0px;
            border-top: 1px solid #bf9696;
            -webkit-transform: rotate(-30deg);
            transform: rotate(0deg);
            top: 12px;
        }

    .compare-image img {
        width: 180px;
        margin-bottom: 15px;
    }

    .div-box-empty-product img {
        width: 180px;
    }

    .div-box-empty-product span {
        margin-top: 15px;
        display: inline-block;
    }

    .div-box-empty-product {
        margin-top: 62px;
        margin-right: 35px;
    }

    .empty-product {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }

    .propertyTilte {
        position: absolute;
        top: -40px;
        font-size: 15px;
        background-color: #fff3e3;
        padding: 4px 50px 4px 50px;
        display: block;
        width: 100%;
    }

    .compare-page .title-compare {
        margin: 20px 50px 0 0;
        font-size: 18px;
        line-height: 31px;
        font-weight: 700;
    }

    .item .item-content .img-compare img {
        width: 130px;
        margin: 10px;
    }

    .item .item-content .text-compare {
        text-align: center;
        margin: 17px 0 22px 0;
        padding: 2px;
    }

    .item .item-content {
        height: 250px;
    }
        .content li {
            position:relative;
        }

        .item .item-content .img-compare {
            text-align: center;
        }

    .item-product .item {
        margin-bottom: 10px;
        float: right;
    }

    .item-product {
        height: 400px;
        overflow: auto;
    }

        .item-product .item .item-content {
            border: 1px solid #ddd;
            border-radius: 7px;
        }

            .item-product .item .item-content:hover {
                cursor: pointer;
                -webkit-box-shadow: 0 8px 9px 0 rgba(0, 0, 0, .05);
                box-shadow: 0 8px 9px 0 rgba(0, 0, 0, .05);
            }

    .modal-body .search-box button {
        margin-top: 0;
    }

    .modal-content .modal-header button {
        left: 27px !important;
        right: unset !important;
    }

    .compare-page .div-compare-details .content .value-list-compare {
        /*border-right: 1px solid #e4e4e4;*/
    }

        .compare-page .div-compare-details .content .value-list-compare:first-child {
            /*border-right: none;*/
        }

    .compare-page .div-compare-details ul li {
        display: flex;
        flex-wrap: wrap;
        margin: 10px 0;
    }

    .compare-page .div-compare-details .content .block {
        /*padding: 14px 18px 12px;*/
        font-size: 14px;
        /*line-height: 1.571;*/
        color: #4d4d4d;
        letter-spacing: -.3px;
        min-height: 25px;
        position: relative;
        display: flex;
        align-items: center;
        height: 100%;
        justify-content: center;
    }

    .compare-page .div-compare-details .content .value-list-compare {
        max-width: 25%;
        position: relative;
        width: 100%;
        min-height: 1px;
        padding-right: 0;
        padding-left: 0;
    }

    .compare-page .div-compare-details {
        margin-top: 35px;
    }

        .compare-page .div-compare-details .content .title-details {
            flex: 0 0 100%;
            max-width: 100%;
            font-size: 13px;
            font-size: .929rem;
            line-height: 1.692;
            padding: 30px 26px;
            background-color: #f5f5f5;
            font-weight: 700;
        }

    .compare-page .row {
        margin: 35px 10px 35px 10px;
        background-color: #fff;
    }

    .compare-page .div-box {
        position: relative;
    }

        .compare-page .div-box .close-product-box {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            background-color: #f5f5f5;
            position: absolute;
            left: 12px;
            top: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            line-height: 30px;
            z-index: 4;
            cursor: pointer;
        }

        .compare-page .div-box .box {
            text-align: center;
            padding: 20px;
            position: relative;
        }

    .price-discount {
        position: absolute;
        top: 50px;
        left: 60px;
    }

    .compare-page .div-box {
        border-left: 1px solid #ddd;
        border-bottom: 2px solid #00bfd6;
        width: 25%;
    }

    .compare-page .div-box-add {
        border-bottom: 2px solid #00bfd6;
        width: 25%;
    }

    .compare-page .div-box:after {
        width: 0;
        height: 0;
        border-color: transparent transparent #00bfd6;
        border-style: solid;
        border-width: 0 10px 10px;
        position: absolute;
        bottom: 0;
        left: 48%;
        margin-left: -5px;
        content: "";
    }

    .compare-page .div-box .box .product-name {
        height: 45px;
        overflow: hidden;
        margin-bottom: 25px;
    }

        .compare-page .div-box .box .product-name span {
            text-overflow: ellipsis;
        }

    .compare-page .div-box .box .price {
        color: #666;
        letter-spacing: .8px;
        font-weight: bold;
        position: relative;
    }

 

    .compare-page .div-box-add .box .div-btn {
        padding-left: 18px;
        padding-right: 18px;
    }

    .compare-page .div-box-add .box .add-btn {
        width: 100%;
        background-color: #7a7a7a;
        transition: all .3s;
    }

    .compare-page .div-box .box .buy-btn:hover {
        background-color: #0bcae1;
        transition: all .3s;
    }

    .c-compare__placement .text-add {
        margin-top: 10px;
        display: inline-block;
        color: #cbcbd1;
        font-size: 14px;
    }

    .c-compare__placement {
        text-align: center;
        padding: 36px;
    }

        .c-compare__placement img {
            width: 150px;
        }

    .add-compare-product {
        border: 5px dashed #d2d2d2;
        border-radius: 7px;
        margin: 20px 8px 25px 8px;
    }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .compare-page .row {
            margin: 18px 0px 35px 10px
        }

        .compare-page .title-compare {
            margin: 120px 50px 0 0;
            font-size: 14px;
            line-height: 31px;
            font-weight: 700;
        }

        .modal-title {
            margin-bottom: 0;
            line-height: 1.5;
            font-size: 15px;
        }
    }
</style>